import { of } from 'rxjs/observable/of';
import { actions, selectApiKey, types } from '../reducers/guest';
import { getGuestOAuth, getGuestProfile } from '../services/guestApi';
import { getHash } from '../util/location';
import { startSession } from '../services/bugsnag';
import * as ldService from '../services/launchDarkly';

export const GetGuestOAuthSession = (action$) =>
  action$
    .ofType(types.GET_GUEST_SESSION)
    .map(getHash)
    .switchMap((hash) => {
      // TODO consider getting this through state so we can remove hash from url
      if (!hash.id_token || hash.id_token.length === 0) {
        return of(actions.noHashError());
      }
      const token = hash.id_token;
      return getGuestOAuth(token)
        .map(actions.getGuestOauthSessionSuccess)
        .catch((err) => of(actions.getGuestOauthSessionFailure(err)));
    });

export const GetGuestProfile = (actions$, store) =>
  actions$.ofType(types.GET_GUEST_SESSION_SUCCESS).switchMap(() => {
    const state = store.getState();
    const apiKey = selectApiKey(state);
    return getGuestProfile(apiKey)
      .map((res) => actions.getGuestProfileSuccess(res))
      .catch((err) => of(actions.getGuestProfileFailure(err)));
  });

// after profile successfully loaded we have enough into to start Bugsnag session
export const GetGuestProfileSuccess = (actions$) =>
  actions$.ofType(types.GET_GUEST_PROFILE_SUCCESS).switchMap((action) => {
    startSession();
    const { profile } = action;
    const ldContext = ldService.getContext();
    ldService.identify({
      ...ldContext,
      kind: 'multi',
      user: {
        key: profile.uid,
        email: profile.emails?.[0]?.value,
        role: profile.customerType,
      },
    });
    return of({ profile: {}, type: '' });
  });

export default [GetGuestOAuthSession, GetGuestProfile, GetGuestProfileSuccess];
